import { Button }                   from '@/components/ui/button'
import CropperModal                 from '../../../components/modal/CropperModal'
import { DialogBody }               from '@/components/ui/dialog'
import { DialogContent }            from '@/components/ui/dialog'
import { DialogFooter }             from '@/components/ui/dialog'
import { DialogHeader }             from '@/components/ui/dialog'
import { DialogRoot }               from '@/components/ui/dialog'
import { DialogTitle }              from '@/components/ui/dialog'
import { Dispatch }                 from 'react';
import { FileUploadDropzone }       from '@/components/ui/file-button'
import { FileUploadRoot }           from '@/components/ui/file-button'
import React                        from 'react';
import { SetStateAction }           from 'react';
import { useTranslation }           from 'react-i18next'
import UserMediaProfilePictureModel from '@/models/services/fondations/UserMediaProfilePictureModel'
import authStore                    from '@/stores/authStore';
import { toaster }                  from '@/components/ui/toaster';

interface IProfilePictureModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	setIsLoading: Dispatch<SetStateAction<boolean>>;
}

const ProfilePictureModal = (props: IProfilePictureModalProps) => {
	const { isOpen, setIsOpen, setIsLoading } = props;
	const { t } = useTranslation();
	const [cropperModalIsOpen, setCropperModalIsOpen] = React.useState(false);
	const [newProfilePicture, setNewProfilePicture] = React.useState<File | undefined>();
	const [imageSource, setImageSource] = React.useState<string>('');
	const currentUser = authStore.currentUser;

	React.useEffect(() => {
		if (newProfilePicture) {
			const newImageSource = URL.createObjectURL(newProfilePicture);
			setImageSource(newImageSource);
		}
	}, [newProfilePicture]);

	const handleCropperSubmit = async (file: File) => {
		const newProfilePicture = await new UserMediaProfilePictureModel().upload(file, { type: file.type || '' }) as UserMediaProfilePictureModel;
		await currentUser.patch({
			userMediaProfilePicture: newProfilePicture.attributes["@id"]
		});
	}

	return (
		<>
			<CropperModal 
				imageSource={imageSource} 
				imageType={newProfilePicture?.type || ''} 
				isOpen={cropperModalIsOpen} 
				setIsOpen={setCropperModalIsOpen} 
				setIsLoading={setIsLoading}
				onSubmit={handleCropperSubmit}
				onSuccess={() => {
					toaster.create({
						title: t('pages.personalInformation.personalInformationBox.modals.cropper.messages.success'),
						type: 'success'
					});
				}}
				onError={() => {
					toaster.create({
						title: t('pages.personalInformation.personalInformationBox.modals.cropper.messages.errors.error'),
						type: 'error'
					});
				}}
			/>
			<DialogRoot 
				size={{ base: 'xs', lg: 'lg' }}
				open={isOpen}
			>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>{t('pages.personalInformation.personalInformationBox.modals.profilePicture.title')}</DialogTitle>
					</DialogHeader>
					<DialogBody>
						<FileUploadRoot 
							alignItems="stretch" 
							maxFiles={1}
							accept={["image/jpeg", "image/png"]}
							onFileAccept={(fileAcceptDetails) => {
								const { files } = fileAcceptDetails;
								const file = files[0];
								setNewProfilePicture(file);
								setIsOpen(false);
								setCropperModalIsOpen(true)
							}}
						>
							<FileUploadDropzone
								label={t('pages.personalInformation.personalInformationBox.modals.profilePicture.actions.drag')}
							/>
						</FileUploadRoot>
					</DialogBody>
					<DialogFooter>
						<Button 
							variant="outline"
							onClick={() => setIsOpen(false)}
						>
							{t('pages.personalInformation.personalInformationBox.modals.profilePicture.actions.cancel')}
						</Button>
					</DialogFooter>
				</DialogContent>
		</DialogRoot>
		</>
	)
}

export default ProfilePictureModal